module.exports = __webpack_public_path__ + "static/media/Lens-Accent_HK.1894f617.png";